import { Pressable, View } from 'react-native';
import { useRouter } from 'expo-router';
import { api } from '@ppwr/convex/_generated/api';
import { useQuery } from 'convex/react';

import { DS } from '@/design-system'

import { useStore } from '@/models'

import Diamond from '@/assets/diamonds/Diamond.svg';


type DiamondCountProps = {
  backgroundColor?: string
  textColor?: string
  isPressable?: boolean
}

function useDiamonds() {
  return useQuery(api.diamonds.queries.getMyDiamonds, {});
}


function DiamondCountDisplay(props: DiamondCountProps) {
  const { session: { isAdmin, isSuperAdmin } } = useStore()

  if (!isAdmin && !isSuperAdmin) {
    return null
  }

  return (
    <DiamondCount {...props} />
  )
}


function DiamondCount({
  backgroundColor = DS.palette['Brand/Light Grey'],
  textColor = DS.palette['Global/Black'],
  isPressable = true
}: DiamondCountProps) {

  const router = useRouter()

  const diamonds = useDiamonds();

  const diamondCount = diamonds?.balance || 0;

  function handlePress(){
    if (isPressable){
      router.push('/diamonds')
    }
  }

  return (
    <Pressable onPress={handlePress}>
      <View style={{position: "relative", flexDirection: 'row', gap: 4, alignItems: "center"}}>
        {/*background*/}
        <View style={{opacity:0.0, position: "absolute", left:0, right:0, top:3, bottom:3, borderRadius: 24, backgroundColor, zIndex: 0}}></View>
        {/*diamond*/}
        <Diamond preserveAspectRatio="xMaxYMid meet" height="120%" style={{zIndex:1}}/>
        {/*diamond count*/}
        <View style={{paddingRight: 8}}>
          <DS.Text style={{lineHeight:0, color:textColor, zIndex:2}} variant="Body Small/Medium">{diamondCount}</DS.Text>
        </View>

      </View>
    </Pressable>
  );
}

export { DiamondCountDisplay };
